import LegalDoc from "@/components/LegalDoc";

export default function Legal() {
  return (
    <LegalDoc
      testid="legal-page"
      title="Legal & company information"
      updated="June 2026"
      intro="Formal provider and company information will be published here before public launch."
      sections={[
        { h: "Service provider", list: [
          "Registered company name: [To be completed]",
          "Company registration number: [To be completed]",
          "VAT / MVA number: [To be completed]",
          "Registered address: [To be completed]",
          "Country of registration: [To be completed]",
        ] },
        { h: "Contact", list: [
          "General contact email: [To be completed]",
          "Privacy / data protection contact: [To be completed]",
        ] },
        { h: "Sub-processors", p: "A list of the processors used to run the service (hosting, database, email delivery and AI providers) will be published here. [To be completed with named providers.]" },
        { h: "Status", p: "This page is a draft structure and is not yet the final, published legal notice." },
      ]}
    />
  );
}
